/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import Filter, { FilterableProps } from '../Filter'
import { handleChangeEvent } from '../../../../client/js/lib/form'
import { Radio } from '@mantine/core'

function WithInvoiceFilter (props: FilterableProps) {
  const { onChange, value } = props
  const intl = useIntl()
  return (
    <Filter>
      <Radio
        checked={value == null}
        id="with_invoice_all_filter"
        label={intl.formatMessage({
          id: 'all',
          defaultMessage: 'Tout'
        })}
        name="withInvoice"
        onChange={handleChangeEvent(onChange)}
        value=""
      />
      <Radio
        checked={value === 'true'}
        id="with_invoice_filter"
        label={intl.formatMessage({
          id: 'with_invoice',
          defaultMessage: 'Avec facture'
        })}
        name="withInvoice"
        onChange={handleChangeEvent(onChange)}
        value="true"
      />
      <Radio
        checked={value === 'false'}
        id="without_invoice_filter"
        label={intl.formatMessage({
          id: 'without_invoice',
          defaultMessage: 'Sans facture'
        })}
        name="withInvoice"
        onChange={handleChangeEvent(onChange)}
        value="false"
      />
    </Filter>
  )
}

export default WithInvoiceFilter
